module.exports = __webpack_public_path__ + "static/media/natuna-logo.e998024e.png";